import { IItemGroupSelectBehavior } from "../../../../documaker/domain/format/objects";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface IItemGroupSelectBehaviorPropertyEditable {
  itemGroupSelectBehavior(): IPropertyEditable<IItemGroupSelectBehavior>;
}

export function instanceOfIItemGroupSelectBehaviorPropertyEditable(instance: any): instance is IItemGroupSelectBehaviorPropertyEditable {
  return instance
      && instance.itemGroupSelectBehavior
      && instanceOfIPropertyEditable<IItemGroupSelectBehavior>(instance.itemGroupSelectBehavior());
}
